<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Tlačiarne C2326, C3224, C3326, C3426, CS331, CS431, CS439">
     Tlačiarne C2326, C3224, C3326, C3426, CS331, CS431, CS439
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sk" title="Bezpečnostn&eacute; inform&aacute;cie">
     Bezpečnostn&eacute; inform&aacute;cie
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Zauž&iacute;van&eacute; označenie">
      Zauž&iacute;van&eacute; označenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Vyhl&aacute;senia o&nbsp;produkte">
      Vyhl&aacute;senia o&nbsp;produkte
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_sk" title="Obozn&aacute;menie sa s&nbsp;tlačiarňou">
     Obozn&aacute;menie sa s&nbsp;tlačiarňou
    </a>
   </p>
   <div id="divd0e173">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sk" title="Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni">
      Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_sk" title="Vyhľadanie s&eacute;riov&eacute;ho č&iacute;sla tlačiarne">
      Vyhľadanie s&eacute;riov&eacute;ho č&iacute;sla tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sk" title="Konfigur&aacute;cie tlačiarne">
      Konfigur&aacute;cie tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sk" title="Použ&iacute;vanie ovl&aacute;dacieho panela">
      Použ&iacute;vanie ovl&aacute;dacieho panela
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sk" title="Prisp&ocirc;sobenie domovskej obrazovky">
      Prisp&ocirc;sobenie domovskej obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sk" title="Vysvetlenie stavu svetla indik&aacute;tora">
      Vysvetlenie stavu svetla indik&aacute;tora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e627" title="V&yacute;ber papiera">
      V&yacute;ber papiera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_sk" title="Pr&iacute;prava na použ&iacute;vanie, in&scaron;tal&aacute;cia a&nbsp;konfigur&aacute;cia">
     Pr&iacute;prava na použ&iacute;vanie, in&scaron;tal&aacute;cia a&nbsp;konfigur&aacute;cia
    </a>
   </p>
   <div id="divd0e1351">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_sk" title="V&yacute;ber miesta pre tlačiareň">
      V&yacute;ber miesta pre tlačiareň
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sk" title="Prip&aacute;janie k&aacute;blov">
      Prip&aacute;janie k&aacute;blov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_sk" title="In&scaron;tal&aacute;cia voliteľn&yacute;ch z&aacute;sobn&iacute;kov">
      In&scaron;tal&aacute;cia voliteľn&yacute;ch z&aacute;sobn&iacute;kov
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1549" title="Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke">
      Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e1676" title="Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;">
      Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1851" title="In&scaron;tal&aacute;cia a&nbsp;aktualiz&aacute;cia softv&eacute;ru, ovl&aacute;dačov a&nbsp;firmv&eacute;ru">
      In&scaron;tal&aacute;cia a&nbsp;aktualiz&aacute;cia softv&eacute;ru, ovl&aacute;dačov a&nbsp;firmv&eacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e2110" title="Pripojenie k&nbsp;sieti">
      Pripojenie k&nbsp;sieti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_sk" title="Tlač strany nastaven&iacute; pon&uacute;k">
      Tlač strany nastaven&iacute; pon&uacute;k
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_sk" title="Zabezpečenie tlačiarne">
     Zabezpečenie tlačiarne
    </a>
   </p>
   <div id="divd0e2555">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sk" title="Vymazanie pam&auml;te tlačiarne">
      Vymazanie pam&auml;te tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sk" title="Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;">
      Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_sk" title="Prehl&aacute;senie o nest&aacute;losti">
      Prehl&aacute;senie o nest&aacute;losti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_sk" title="Tlač">
     Tlač
    </a>
   </p>
   <div id="divd0e2677">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sk" title="Tlač z poč&iacute;tača">
      Tlač z poč&iacute;tača
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2703" title="Tlač z&nbsp;mobiln&eacute;ho zariadenia">
      Tlač z&nbsp;mobiln&eacute;ho zariadenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sk" title="Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh">
      Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sk" title="Tlač d&ocirc;vern&yacute;ch a&nbsp;in&yacute;ch zadržan&yacute;ch &uacute;loh">
      Tlač d&ocirc;vern&yacute;ch a&nbsp;in&yacute;ch zadržan&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_sk" title="Tlač z&nbsp;profilu konektora Cloud">
      Tlač z&nbsp;profilu konektora Cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_sk" title="Tlač zoznamu uk&aacute;žok p&iacute;siem">
      Tlač zoznamu uk&aacute;žok p&iacute;siem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_sk" title="Umiestnenie oddeľovac&iacute;ch h&aacute;rkov medzi k&oacute;pie">
      Umiestnenie oddeľovac&iacute;ch h&aacute;rkov medzi k&oacute;pie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sk" title="Zru&scaron;enie tlačovej &uacute;lohy">
      Zru&scaron;enie tlačovej &uacute;lohy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sk" title="&Uacute;prava tmavosti tonera">
      &Uacute;prava tmavosti tonera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sk" title="Použ&iacute;vanie pon&uacute;k tlačiarne">
     Použ&iacute;vanie pon&uacute;k tlačiarne
    </a>
   </p>
   <div id="divd0e3245">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_sk" title="Mapa pon&uacute;k">
      Mapa pon&uacute;k
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3502" title="Zariadenie">
      Zariadenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e4994" title="Tlač">
      Tlač
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e5942" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6182" title="Sieť/porty">
      Sieť/porty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8172" title="Zabezpečenie">
      Zabezpečenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_sk" title="Cloudov&yacute; konektor">
      Cloudov&yacute; konektor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e8828" title="Spr&aacute;vy">
      Spr&aacute;vy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_sk" title="Rie&scaron;enie probl&eacute;mov">
      Rie&scaron;enie probl&eacute;mov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sk" title="&Uacute;držba tlačiarne">
     &Uacute;držba tlačiarne
    </a>
   </p>
   <div id="divd0e9031">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_sk" title="Kontrola stavu s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      Kontrola stavu s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_sk" title="Konfigur&aacute;cia ozn&aacute;men&iacute; o&nbsp;spotrebnom materi&aacute;li">
      Konfigur&aacute;cia ozn&aacute;men&iacute; o&nbsp;spotrebnom materi&aacute;li
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sk" title="Nastavenie upozornen&iacute; e-mailom">
      Nastavenie upozornen&iacute; e-mailom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_sk" title="Zobrazenie spr&aacute;v">
      Zobrazenie spr&aacute;v
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sk" title="Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e9850" title="V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu">
      V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e10048" title="Čistenie s&uacute;čast&iacute; tlačiarne">
      Čistenie s&uacute;čast&iacute; tlačiarne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e10169" title="&Uacute;spora energie a&nbsp;papiera">
      &Uacute;spora energie a&nbsp;papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_sk" title="Premiestnenie tlačiarne na in&eacute; miesto">
      Premiestnenie tlačiarne na in&eacute; miesto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_sk" title="Doprava tlačiarne">
      Doprava tlačiarne
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_sk" title="Rie&scaron;enie probl&eacute;mov">
     Rie&scaron;enie probl&eacute;mov
    </a>
   </p>
   <div id="divd0e10330">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_sk" title="Probl&eacute;my s kvalitou tlače">
      Probl&eacute;my s kvalitou tlače
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e10430" title="Probl&eacute;my s&nbsp;tlačou">
      Probl&eacute;my s&nbsp;tlačou
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_sk" title="Tlačiareň nereaguje">
      Tlačiareň nereaguje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e12835" title="Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m">
      Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13054" title="Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom">
      Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_sk" title="Odstr&aacute;nenie zaseknut&eacute;ho papiera">
      Odstr&aacute;nenie zaseknut&eacute;ho papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e13491" title="Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera">
      Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e13873" title="Probl&eacute;my s kvalitou farieb">
      Probl&eacute;my s kvalitou farieb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sk" title="Kontaktovanie podpory pre z&aacute;kazn&iacute;kov">
      Kontaktovanie podpory pre z&aacute;kazn&iacute;kov
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_sk" title="Recykl&aacute;cia a likvid&aacute;cia">
     Recykl&aacute;cia a likvid&aacute;cia
    </a>
   </p>
   <div id="divd0e14112">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_sk" title="Recykl&aacute;cia produktov Lexmark">
      Recykl&aacute;cia produktov Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sk" title="Recykl&aacute;cia obalov Lexmark">
      Recykl&aacute;cia obalov Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sk" title="Ozn&aacute;menia">
     Ozn&aacute;menia
    </a>
   </p>
   <div id="divd0e14147">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14150" title="Inform&aacute;cie o&nbsp;produkte">
      Inform&aacute;cie o&nbsp;produkte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14167" title="Pozn&aacute;mky k&nbsp;vydaniu">
      Pozn&aacute;mky k&nbsp;vydaniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sk" title="Ochrann&eacute; zn&aacute;mky">
      Ochrann&eacute; zn&aacute;mky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sk" title="Inform&aacute;cie o&nbsp;licencovan&iacute;">
      Inform&aacute;cie o&nbsp;licencovan&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sk" title="Hladiny emisi&iacute; hluku">
      Hladiny emisi&iacute; hluku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sk" title="Smernica o&nbsp;odpade z&nbsp;elektrick&yacute;ch a&nbsp;elektronick&yacute;ch zariaden&iacute; (WEEE)">
      Smernica o&nbsp;odpade z&nbsp;elektrick&yacute;ch a&nbsp;elektronick&yacute;ch zariaden&iacute; (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14264" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sk" title="Likvid&aacute;cia produktu">
      Likvid&aacute;cia produktu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14298" title="Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria">
      Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sk" title="Nariadenie (E&Uacute;) 2023/1542">
      Nariadenie (E&Uacute;) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sk" title="Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu">
      Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sk" title="Upozornenie o&nbsp;statickej citlivosti">
      Upozornenie o&nbsp;statickej citlivosti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sk" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sk" title="Inform&aacute;cie o teplot&aacute;ch">
      Inform&aacute;cie o teplot&aacute;ch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sk" title="Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;">
      Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sk" title="Spotreba energie">
      Spotreba energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14549" title="Regulačn&eacute; upozornenia t&yacute;kaj&uacute;ce sa bezdr&ocirc;tov&yacute;ch produktov.">
      Regulačn&eacute; upozornenia t&yacute;kaj&uacute;ce sa bezdr&ocirc;tov&yacute;ch produktov.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sk" title="Pozn&aacute;mka o&nbsp;&scaron;tandardn&yacute;ch komponentoch">
      Pozn&aacute;mka o&nbsp;&scaron;tandardn&yacute;ch komponentoch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sk" title="Vystavenie r&aacute;diofrekvenčn&eacute;mu žiareniu">
      Vystavenie r&aacute;diofrekvenčn&eacute;mu žiareniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14575" title="Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)">
      Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_sk" title="Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)">
      Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue